import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersist({
    storage: window.localStorage,
})

export default new Vuex.Store({
    state: {
        createTemplateTitle: '创建呱呱问卷', // 用于控制不同入口进入createTemplate页面的title名称
        labelNames: [],
        tid: '',
        topicList: [],
        showTopicList: [], // 用于显示条件
        relate: null, // 多个显示条件的关系
        showJson: '', // 显示条件的showJson字段
        showConfirm: false, // 显示条件页面确认按钮
        labelObj: null,
        model: null,
        topicName: '',
        skipObj: '',
        rangeList: [], // 发送范围
        publishData: {
            pageId: '',
            loginType: '',
            loginTypeName: '',
            sendType: '',
            sendTypeName: '',
            haveRange: '',
        },
        templateData: {
            pageId: '',
            templateName: '',
            sheetShow: false,
        }
    },
    mutations: {
        updateCreateTemplateTitle(state, val) {
            state.createTemplateTitle = val
        },
        updateTemplateData(state, val) {
            state.templateData = val
        },
        removeTemplateData(state) {
            state.templateData = {
                pageId: '',
                templateName: '',
                sheetShow: false,
            }
        },
        updateLabelNames(state, val) {
            state.labelNames = val
        },
        updateRangeList(state, rangeListItem) {
            let index = state.rangeList.findIndex(item => item.sendType === rangeListItem.sendType)
            if (index === -1) {
                state.rangeList.push(rangeListItem) 
            } else {
                state.rangeList[index] = rangeListItem
            }
        },
        saveRangeList(state, rangeList) {
            state.rangeList = rangeList
        },
        updatePublishData(state, val) {
            state.publishData = val
        },
        removePublishData(state) {
            state.publishData = {
                pageId: '',
                loginType: '',
                loginTypeName: '',
                sendType: '',
                sendTypeName: '',
                haveRange: '',
                smsContent: '',
                signType: '',
                signTypeName: ''
            }
        },
        removeRangeList (state) {
            state.rangeList = []
        },
        updateTid(state, tid) {
            state.tid = tid
        },
        updateTopicList(state, topicInfo) {
            state.topicList.push(topicInfo)
        },
        updateShowTopicList(state, val) {
            state.showTopicList = val
        },
        updateRelate(state, val) {
            state.relate = val
        },
        updateShowJson(state, val) {
            state.showJson = val
        },
        updateShowConfirm(state, val) {
            state.showConfirm = val
        },
        updateModel(state, val) {
            state.model = val
        },
        updateTopicName(state, val) {
            state.topicName = val
        },
        updateSkipObj(state, val) {
            state.skipObj = val
        },
        updateLabelObj(state, val) {
            state.labelObj = val
        },
    },
    actions: {
    },
    modules: {
    },
    plugins: [vuexLocal.plugin],
})
